import React from "react"
import { Navigate, useSearchParams } from "react-router-dom"

import { RoutesPaths } from "../../constants/routes.ts"

const PROJECT_ARCHIVE_VIEW = "archive"

/**
 * `/projects/list?view=archive` used to be the Projects page's Archive tab.
 * The list no longer reads `view` from the URL — it is a prop of the mount
 * now — so without this the old link would land on the *active* list with no
 * hint that anything was ignored. Bookmarks and any external link keep
 * working, they just arrive at the Archive's Projects tab instead.
 */
export function ProjectsArchiveQueryRedirect({
  children
}: {
  children: React.ReactNode
}) {
  const [searchParams] = useSearchParams()

  if (searchParams.get("view") === PROJECT_ARCHIVE_VIEW) {
    return <Navigate replace to={RoutesPaths.archive.projects} />
  }

  return <>{children}</>
}
